import { render, staticRenderFns } from "./ClientFooter.vue?vue&type=template&id=6014aaa7&scoped=true&"
import script from "./ClientFooter.vue?vue&type=script&lang=js&"
export * from "./ClientFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014aaa7",
  null
  
)

export default component.exports